import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendAudienceTarget,
  BackendMutationRemoveAudienceTargetArgs,
} from 'src/types/backend';

import { FRAGMENT_AUDIENCE_TARGET } from './schema';

const MUTATION = gql`
  mutation RemoveAudienceTarget($projectId: Int!, $id: ID!) {
    removeAudienceTarget(projectId: $projectId, id: $id) {
      ...AudienceTarget
    }
  }
  ${FRAGMENT_AUDIENCE_TARGET}
`;

type Variables = BackendMutationRemoveAudienceTargetArgs;
type Result = BackendAudienceTarget;

export const deleteAudienceTargeting = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
